import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=47f46464"
import script from "./sms.vue?vue&type=script&lang=js"
export * from "./sms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f46464')) {
      api.createRecord('47f46464', component.options)
    } else {
      api.reload('47f46464', component.options)
    }
    module.hot.accept("./sms.vue?vue&type=template&id=47f46464", function () {
      api.rerender('47f46464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/send-boxes/sms.vue"
export default component.exports